export default {
    data: () => ({
      componentKey: 0,
    }),
    methods: {
        forceUpdateCmp() {
            this.$data.componentKey += 1;
        }
    },
}